export enum ContactType {
  applicationFederee = 'applicationFederee',
  espaceUtilisateur = 'espaceUtilisateur',
  mobile = 'mobile',
  communaute = 'communaute',
  echat = 'echat',
  email = 'email',
  callback = 'callback',
  conseiller = 'conseiller',
  djingo = 'djingo',
}

export class Phone {
  phoneNumber: string;
  text: string;

  constructor(phoneNumber: string, text: string) {
    this.phoneNumber = phoneNumber;
    this.text = text;
  }
}

export class Contact {
  type: ContactType;
  text: string;
  url?: string;
  autreInfo?: string;
  listPhone?: Map<string, Phone>;
  text2?: string;
  intention?: string;

  constructor(contactTypeFromApi: string, contactFromApi: ContactFromApi) {
    this.type = ContactType[contactTypeFromApi];
    this.text = contactFromApi.texte;
    this.autreInfo = contactFromApi.autreInfo;
    if (contactTypeFromApi === ContactType.conseiller) {
      this.listPhone = new Map<string, Phone>();
      if (contactFromApi.numero1.length > 0) {
        this.listPhone.set('number1', new Phone(contactFromApi.numero1, contactFromApi.texteNumero1));
      }

      if (contactFromApi.numero2.length > 0) {
        this.listPhone.set('number2', new Phone(contactFromApi.numero2, contactFromApi.texteNumero2));
      }
      if (contactFromApi.numeroDepuisEtranger.length > 0) {
        this.listPhone.set(
          'stranger',
          new Phone(contactFromApi.numeroDepuisEtranger, contactFromApi.texteNumeroDepuisEtranger)
        );
      }
      if (contactFromApi.numero3.length > 0) {
        this.listPhone.set('number3', new Phone(contactFromApi.numero3, contactFromApi.texteNumero3));
      }
    } else if (contactTypeFromApi === ContactType.djingo) {
      this.text2 = contactFromApi.texte2;
      this.intention = contactFromApi.intention;
    } else {
      this.url = contactFromApi.url.trim();
    }
  }
}

export class Tile {
  slug: string;
  title: string;
  level: number;
  daughtersTilesSlug?: string[];
  contacts?: Contact[];

  constructor(tileFromApi: TileFromApi) {
    this.slug = tileFromApi.id;
    this.title = tileFromApi.texte;
    this.level = tileFromApi.niveau;
    this.daughtersTilesSlug = tileFromApi.vignettesFilles;
    this.contacts = [];
    if (tileFromApi.contacts !== null && tileFromApi.contacts !== undefined) {
      Object.entries(tileFromApi.contacts).map((entry) => {
        if (entry[1].active) {
          this.contacts.push(new Contact(entry[0], entry[1]));
        }
      });
    }
  }
}

export interface TileFromApi {
  id: string;
  texte?: string;
  niveau?: number;
  // eslint-disable-next-line @typescript-eslint/ban-types
  contacts?: object;
  vignettesFilles?: string[];
  image?: string;
}

export interface ContactFromApi {
  texte?: string;
  url?: string;
  numero1?: string;
  texteNumero1?: string;
  numero2?: string;
  texteNumero2?: string;
  numeroDepuisEtranger?: string;
  texteNumeroDepuisEtranger?: string;
  numero3?: string;
  texteNumero3?: string;
  autreInfo?: string;
  texte2?: string;
  intention?: string;
  active?: boolean;
}
